import { TextHelper } from 'src/app/utils/text-helper';
import { PersonalAnalysticsService } from './../../../../data/repository/analytics-repository/personal-analystics.service';
import { Subscription } from 'rxjs';
import { PersonalDataService } from './../../../../data/repository/plan-repository/personal-data.service';
import { SnackBarService } from './../../../../data/repository/utils-repository/snack-bar.service';
import {
  CreatePersonalFoodParams,
  FoodFactCreate,
  personalFood,
  RatioArray,
  ResponseGetRatioArray,
} from './../../../../core/model/api-response/persoanl-response-model';
import { PersoanlService } from './../../../../data/repository/plan-repository/persoanl.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';

@Component({
  selector: 'app-create-personal-food',
  templateUrl: './create-personal-food.component.html',
  styleUrls: ['./create-personal-food.component.scss'],
})
export class CreatePersonalFoodComponent implements OnInit, OnDestroy {
  foodname: string = null;
  calorie: number = null;
  foodFactsAmount: number[] = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ];

  foodFactsNames = [
    'پروتئین',
    'کربوهیدرات',
    'چربی',
    'قند',
    'فیبر',
    'سدیم',
    'پتاسیم',
    'کلسیم',
    'منیزیم',
    'فسفر',
    'آهن',
    'اسید چرب اشباع',
    'اسید های چرب تک غیر اشباع',
    'اسیدهای چرب چند غیر اشباع',
    'اسید چرب ترانس',
    'کلسترول',
  ];
  foodFactsUnits = [
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'میلی گرم',
  ];
  ready: boolean = false;
  edit: boolean = false;
  editPersonal: personalFood = null;
  id: string;
  lastEditId: string = '';
  bottomSheetUnint: boolean = false;
  bottomSheetUnintShow: boolean = false;
  foodUnitArray: [RatioArray, ResponseGetRatioArray][] = null;
  Subscriptions: Subscription[] = [];

  constructor(
    private planService: PlanService,
    private route: ActivatedRoute,
    private persoanlService: PersoanlService,
    private snackBarService: SnackBarService,
    private personalDataService: PersonalDataService,
    private personalAnalysticsService: PersonalAnalysticsService,
    private textHelper: TextHelper
  ) {
    this.edit = this.route.snapshot.paramMap.get('edit') === 'true';
    this.personalDataService.closeBottomSheet$.subscribe(() => {});
    this.Subscriptions[0] =
      this.personalDataService.closeBottomSheet$.subscribe((data) => {
        if (data) {
          this.bottomSheetUnintShow = false;
          setTimeout(() => {
            this.bottomSheetUnint = false;
          }, 300);
          this.lastEditId = '';
          this.personalDataService.clearEditRatio();
        }
      });
    this.Subscriptions[1] = this.personalDataService.openBottomSheet$.subscribe(
      (close) => {
        if (close) {
          this.bottomSheetUnint = true;
          setTimeout(() => {
            this.bottomSheetUnintShow = true;
          }, 300);
        }
      }
    );
    this.Subscriptions[2] =
      this.personalDataService.closeAndUpdateBottomSheet$.subscribe((res) => {
        if (res) {
          this.addFoodRation(res.ratio, res.calorie);
          this.bottomSheetUnintShow = false;
          setTimeout(() => {
            this.bottomSheetUnint = false;
          }, 300);
        }
      });
    this.Subscriptions[3] = this.personalDataService.closeAndRemove$.subscribe(
      (id) => {
        if (id) {
          this.removeFood(id);
          this.bottomSheetUnintShow = false;
          setTimeout(() => {
            this.bottomSheetUnint = false;
            this.lastEditId = '';
            this.personalDataService.clearEditRatio();
          }, 300);
        }
      }
    );
    if (this.edit) {
      if (this.personalDataService.editFood) {
        this.initEdit();
      } else {
        this.back();
      }
    }
  }
  addFoodRation(d: ResponseGetRatioArray, n: number) {
    const ratio = new RatioArray(n, d.id);
    if (!this.foodUnitArray) {
      this.foodUnitArray = [[ratio, d]];
    } else {
      const key = this.foodUnitArray.findIndex(
        (v) => v[0].unitId == this.lastEditId
      );
      if (key >= 0) {
        this.foodUnitArray[key] = [ratio, d];
        this.lastEditId = '';
        this.personalDataService.clearEditRatio();
      } else {
        this.foodUnitArray.push([ratio, d]);
      }
    }
    this.personalDataService.clearEditRatio();
  }
  removeFood(id: string) {
    this.foodUnitArray = this.foodUnitArray.filter((v) => v[0].unitId !== id);
    this.lastEditId = '';
    this.personalDataService.clearEditRatio();
  }
  ngOnDestroy() {
    this.Subscriptions.forEach((sb) => {
      sb.unsubscribe();
    });
  }
  initEdit() {
    this.editPersonal = this.personalDataService.editFood;
    this.foodname = this.editPersonal.name;
    this.calorie = this.editPersonal.foodFact.calorieAmount;
    this.id = this.editPersonal._id;
    this.foodFactsAmount = [
      this.editPersonal.foodFact.proteinAmount,
      this.editPersonal.foodFact.carbohydrateAmount,
      this.editPersonal.foodFact.fatAmount,
      this.editPersonal.foodFact.sugarAmount,
      this.editPersonal.foodFact.fiberAmount,
      this.editPersonal.foodFact.sodiumAmount,
      this.editPersonal.foodFact.potassiumAmount,
      this.editPersonal.foodFact.calciumAmount,
      this.editPersonal.foodFact.magnesiumAmount,
      this.editPersonal.foodFact.phosphorAmount,
      this.editPersonal.foodFact.ironAmount,
      this.editPersonal.foodFact.saturatedFatAmount,
      this.editPersonal.foodFact.polyunsaturatedFatAmount,
      this.editPersonal.foodFact.monounsaturatedFatAmount,
      this.editPersonal.foodFact.transFatAmount,
      this.editPersonal.foodFact.cholesterolAmount,
    ];
    this.foodUnitArray = this.editPersonal.foodUnitRatioArray.map((v) => {
      const r = new RatioArray(v.ratio, v.unitId._id);
      const d = new ResponseGetRatioArray(
        v.unitId.name,
        v.unitId.deleted,
        v.unitId._id,
        v.unitId.updatedAt,
        v.unitId.createdAt,
        v.unitId._id
      );
      const f = v.unitId.name;
      return [r, d] as [RatioArray, ResponseGetRatioArray];
    });
    this.changeEditValues(this.foodFactsAmount);
    this.change();
  }
  ngOnInit() {}
  back() {
    this.planService.goBack();
  }
  newFoodRatio() {
    if (this.foodUnitArray) {
      const ids = this.foodUnitArray.map((d) => d[0].unitId);

      this.personalDataService.saveIds(ids);
    }
    this.personalDataService.openBottomSheet();
  }
  changeEditValues(foodFactsAmount: any[]) {
    this.foodFactsAmount = foodFactsAmount.map((f) => {
      return f == '-1' ? null : parseInt(f);
    });
  }
  change() {
    if (
      this.foodname !== null &&
      this.foodname !== '' &&
      this.calorie !== null &&
      this.calorie >= 0
    ) {
      this.ready = true;
    } else {
      this.ready = false;
    }
  }
  submit() {
    if (this.ready) {
      const fixedfact = this.foodFactsAmount.map(
        (f) =>
          (f
            ? parseInt(this.textHelper.replacePersian(f.toString()))
            : -1) as number
      );
      const facts = new FoodFactCreate(
        this.calorie,
        fixedfact[0],
        fixedfact[1],
        fixedfact[2],
        fixedfact[3],
        fixedfact[4],
        fixedfact[5],
        fixedfact[6],
        fixedfact[7],
        fixedfact[8],
        fixedfact[9],
        fixedfact[10],
        fixedfact[11],
        fixedfact[12],
        fixedfact[13],
        fixedfact[14],
        fixedfact[15]
      );
      let foodRatio: RatioArray[] = null;
      let primary = '5e1c595d883a966e03fb4530';
      if (this.foodUnitArray && this.foodUnitArray.length > 0) {
        foodRatio = this.foodUnitArray.map((v) => v[0] as RatioArray);
        primary = this.foodUnitArray[0][0].unitId;
      }
      const params = new CreatePersonalFoodParams(
        facts,
        this.foodname,
        primary,
        foodRatio
      );
      this.persoanlService.createPersonalFood(params).then((res) => {
        if (res.isSuccess()) {
          this.personalAnalysticsService.analyticCreatePersonalFood();
          this.personalAnalysticsService.analyticCreatePersonalPackage();

          this.snackBarService.showSnackBar('غذای شخصی شما با موفقیت ساخته شد');
          this.planService.goBack();
        }
      });
    }
  }
  update() {
    if (this.ready) {
      const fixedfact = this.foodFactsAmount.map(
        (f) =>
          (f
            ? parseInt(this.textHelper.replacePersian(f.toString()))
            : -1) as number
      );
      const facts = new FoodFactCreate(
        this.calorie,
        fixedfact[0],
        fixedfact[1],
        fixedfact[2],
        fixedfact[3],
        fixedfact[4],
        fixedfact[5],
        fixedfact[6],
        fixedfact[7],
        fixedfact[8],
        fixedfact[9],
        fixedfact[10],
        fixedfact[11],
        fixedfact[12],
        fixedfact[13],
        fixedfact[14],
        fixedfact[15]
      );
      let foodRatio: RatioArray[] = null;
      let primary = '5e1c595d883a966e03fb4530';
      if (this.foodUnitArray && this.foodUnitArray.length > 0) {
        foodRatio = this.foodUnitArray.map((v) => v[0] as RatioArray);
        primary = this.foodUnitArray[0][0].unitId;
      }
      const params = new CreatePersonalFoodParams(
        facts,
        this.foodname,
        primary,
        foodRatio
      );
      this.persoanlService.updatePeronalFood(this.id, params).then((res) => {
        if (res.isSuccess()) {
          this.personalAnalysticsService.analyticEditPersonalFood();
          this.personalAnalysticsService.analyticEditPersonalPackage();

          this.snackBarService.showSnackBar('غذای شخصی شما با موفقیت اپدیت شد');
          this.planService.goBack();
        }
      });
    }
  }
  delete() {
    this.persoanlService.deletePersonalFood(this.id).then((res) => {
      this.personalAnalysticsService.analyticDeletePersonalPackage();
      this.snackBarService.showSnackBar('غذای شخصی شما با موفقیت حذف شد');
      this.personalAnalysticsService.analyticDeletePersonalFood();

      this.planService.goBack();
    });
  }
  cancel() {
    this.planService.goBack();
  }
  updateSelect(ratio: [RatioArray, ResponseGetRatioArray]) {
    this.lastEditId = ratio[0].unitId;
    const ids = this.foodUnitArray.map((d) => d[0].unitId);
    this.personalDataService.openBottomSheet(ratio, ids);
  }
}
